// extracted by mini-css-extract-plugin
module.exports = {"list":"SocialsList-module--list--34bu0","link":"SocialsList-module--link--25UwE"};